<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    item-text="nomeLocal"
    item-value="id"
    label="Local de entrega"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    @change="onChange"
    v-bind="$attrs">
    <template v-slot:item="item">
      <v-list-item-content>
        <v-list-item-title>
          <px-chip-codigo-interno :codigo-interno="item.item.codigoInterno"/>
          {{ item.item.nomeLocal }}
        </v-list-item-title>
        <v-list-item-subtitle>
          <span>{{ item.item.endereco | endereco }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <template v-slot:selection="item">
      <px-chip-codigo-interno :codigo-interno="item.item.codigoInterno"/>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span v-on="on">
            {{ item.item.nomeLocal }}
          </span>
        </template>
        <span>{{ item.item.endereco | endereco }}</span>
      </v-tooltip>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import LocaisEntregaService from '@/api/locais-entrega-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      if (!val || (this.localValue && this.localValue.nomeLocal === val)) return;
      this.debounceSearch(val);
    },
    value() {
      if (this.value) {
        this.items = [this.value, ...this.items];
      }
    },
  },
  methods: {
    searchItems(val) {
      const searchValue = val || '';

      this.loading = true;
      LocaisEntregaService.getLocaisEntrega({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: `ativo is true and (nomeLocal like "%${searchValue.toLowerCase()}%" or codigoInterno like "%${searchValue.toLowerCase()}%")`,
      })
        .then((response) => {
          if (this.value) {
            this.items = [this.value, ...response.data.content];
            return;
          }
          this.items = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange(event) {
      if (event?.nomeLocal) {
        this.$emit('change', event);
      }
    },
    onFocus() {
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchItems, 1000);
    if (this.value) {
      this.items = [this.value];
    }
  },
};
</script>
